export default [
  {
    date: '2017-02-27',
    items: [
      {
        description: 'Search, sort, and filter through rugs. See rug details and download pictures of various types.',
        headline: 'Search Module',
        type: 'feature',
      },
      {
        description: 'See your account information and change your password.',
        headline: 'My Account Module',
        type: 'feature',
      },
      {
        description: 'See all rugs you advise on.',
        headline: 'My Orders Module (Advisors)',
        type: 'feature',
      },
      {
        description: 'See all marked for designers rugs.',
        headline: 'Marked for Designers Module (Designers)',
        type: 'feature',
      },
      {
        description: 'Personalize Carpet to your taste.',
        headline: 'Settings Module',
        type: 'feature',
      },
      {
        description: 'Send us your feedback and found bugs.',
        headline: 'Feedback Module',
        type: 'feature',
      },
    ],
    title: 'Carpet launched!',
    version: '1.0.0',
  },

  {
    date: '2017-03-13',
    items: [
      {
        description: 'Manage users and permissions; add new ones.',
        headline: 'Users (Admins)',
        type: 'feature',
      },
      {
        description: `If you're a designer, recent rugs which were marked for designers are now shown instead of 'My Recent Orders'.`,
        headline: 'Homepage',
        type: 'improvement',
      },
      {
        description: `Renamed 'Dessin' to 'Edges'.`,
        headline: 'General',
        type: 'improvement',
      },
    ],
    title: 'New features, improvements, and bugfixes.',
    version: '1.1.0',
  },

  {
    date: '2017-04-04',
    items: [
      {
        description: `A user's name and email can now be changed.`,
        headline: 'Users (Admins)',
        type: 'improvement',
      },
    ],
    title: 'Improvements and bugfixes.',
    version: '1.1.1',
  },

  {
    date: '2017-04-23',
    items: [
      {
        description: `Export the current results to Excel. This is (currently) limited to the first 1000 results.`,
        headline: 'Search / My Orders / Marked for Designers Module',
        type: 'feature',
      },
      {
        description: `You can now add other advisors to see their rugs in 'My Orders'. Thanks to Michael for the suggestion.`,
        headline: 'Settings Module (Advisors)',
        type: 'feature',
      },
      {
        description: `Added link for admins to monitor the system.`,
        headline: 'Status (Admin)',
        type: 'feature',
      },
      {
        description: `Rug Status (Sold, In Stock, etc.) now also considers the stock quantity. Thanks to Benedikt, David, and Nadine.`,
        headline: 'General',
        type: 'improvement',
      },
      {
        description: `List of advisors is now sorted alphabetically.`,
        headline: 'Search Module',
        type: 'improvement',
      },
      {
        description: `When searching the results always start on the first page. Thanks to Janna für the report.`,
        headline: 'Search Module',
        type: 'bugfix',
      },
      {
        description: `When logging out, the state is reset properly.`,
        headline: 'General',
        type: 'bugfix',
      },
    ],
    title: 'New features, improvements, and bugfixes.',
    version: '1.2.0',
  },

  {
    date: '2017-04-26',
    items: [
      {
        description: `Fixed the height of all rug cards on the main page.`,
        headline: 'Main Module',
        type: 'improvement',
      },
      {
        description: `Fixed showing sold rugs when searching for ones in stock. Thanks to Liesbeth for the report.`,
        headline: 'Search Module',
        type: 'bugfix',
      },
      {
        description: `The extended filters buttons now stays blue correctly as long as extended filters are active.`,
        headline: 'Search Module',
        type: 'bugfix',
      },
    ],
    title: 'Improvements and bugfixes.',
    version: '1.2.1',
  },

  {
    date: '2017-05-11',
    items: [
      {
        description: `Save searches from the search module, give it a name, and load searches at a later time.`,
        headline: 'My Searches Module',
        type: 'feature',
      },
      {
        description: `Changed 'width' to 'length' in search form. Thanks to Liesbeth for the suggestion.`,
        headline: 'Search Module',
        type: 'improvement',
      },
      {
        description: `Advisors can set pictures as primary.`,
        headline: 'General (Advisors)',
        type: 'bugfix',
      },
    ],
    title: 'New features.',
    version: '1.3.0',
  },

  {
    date: '2017-06-26',
    items: [
      {
        description: `User can now reserve rugs by clicking on the "Reserve" Button in the rug details. In the search module it is now possible to search for all rugs that are currently reserved. Users who created or updated a reservation will be notified by email when a reservation starts or ends. Thanks to Kay for the suggestion.`,
        headline: 'Rug Reservation (Search Module)',
        type: 'feature',
      },
    ],
    title: 'New Feature.',
    version: '1.4.0',
  },

  {
    date: '2017-07-05',
    items: [
      {
        description: `When reserving a rug, it is now possible to specifiy an event in addition or instead of a reason.`,
        headline: 'Search Module',
        type: 'improvement',
      },
      {
        description: `Renamed 'Reserved' status to 'Confirmed' and 'On Hold' to 'Reservation'. Thanks to David for the suggestion.`,
        headline: 'Search Module',
        type: 'improvement',
      },
      {
        description: `Users can now search for rugs with current and upcoming reservations.`,
        headline: 'Search Module',
        type: 'improvement',
      },
      {
        description: `Users can now search for rugs with reservations for an specific event.`,
        headline: 'Search Module',
        type: 'improvement',
      },
      {
        description: `When searching for available or reserved rugs, users can now specifiy the date range of the reservation.`,
        headline: 'Search Module',
        type: 'improvement',
      },
      {
        description: `It is now possibled to specify users who created or updated reservations when searching for rugs which have current or upcoming reservations.`,
        headline: 'Search Module',
        type: 'improvement',
      },
      {
        description: `Recent Reservations can't be edited anymore.`,
        headline: 'Search Module',
        type: 'improvement',
      },
      {
        description: `Upcoming reservations a user has created or updated are also shown in the 'My Orders Module' for that user.`,
        headline: 'My Orders Module',
        type: 'improvement',
      },
      {
        description: `Upcoming reservations are now shown in the rug card.`,
        headline: 'My Orders Module',
        type: 'improvement',
      },
    ],
    title: 'Improvements.',
    version: '1.4.5',
  },

  {
    date: '2017-07-11',
    items: [
      {
        description: `When clicking on the camera icon on the rug card, a preview modal will open. Users can click through the primary picture of all rugs on the current page. Thanks to Kay for the suggestion.`,
        headline: 'Preview (Main, Marked for Designers, My Orders, and Search Module)',
        type: 'feature',
      },
      {
        description: `When clicking on a picture in the rug detail module, a preview modal will open. Users can click through the pictures of the current rug. Thanks to Kay for the suggestion.`,
        headline: 'Preview (Rug Detail Module)',
        type: 'feature',
      },
      {
        description: `Rug Cards now show the picture count.`,
        headline: 'General',
        type: 'improvement',
      },
      {
        description: `Shown recent rugs are now displayed according to the user's role and/or whether appropriate rugs could be found.`,
        headline: 'Main Module',
        type: 'improvement',
      },
    ],
    title: 'New Feature & Improvements.',
    version: '1.5.0',
  },

  {
    date: '2017-08-19',
    items: [
      {
        description: `Shipping pictures from producers are now automatically imported into Carpet. This also introduces a new picture source - shipping pictures. Thanks to David for the suggestion.`,
        headline: 'Producer Interface',
        type: 'feature',
      },
      {
        description: `When the preview isn't expanded, the rug ID and name are shown. Thanks to Roman for the suggestion.`,
        headline: 'Preview',
        type: 'improvement',
      },
      {
        description: `Removed references to C3 in picture file types.`,
        headline: 'Rug Detail Module',
        type: 'improvement',
      },
      {
        description: `Hint that users can save searches from the search module.`,
        headline: 'My Searches Module',
        type: 'improvement',
      },
    ],
    title: 'Features & Improvements.',
    version: '1.6.0',
  },

  {
    date: '2017-08-22',
    items: [
      {
        description: `The status of a rug should never be null. Thanks to Jasper for the report.`,
        headline: 'General',
        type: 'bugfix',
      },
    ],
    title: 'Bugfix.',
    version: '1.6.1',
  },

  {
    date: '2017-09-04',
    items: [
      {
        description: `Advisors can now request specific rugs for designers to improve the pictures of. Whenever a rug is requested all designer will get an email (this can be disabled in the settings). Whenever a request is fulfilled, the creator is notified by email. There is also an overview (Requested Rugs) that lists all rugs that were requested as well as an Designer Queue with all rugs which were scanned after this update that don't have an designer picture yet. Thanks to Jan for the suggestion.`,
        headline: 'Rug Requests (Advisors & Designers)',
        type: 'feature',
      },
    ],
    title: 'New Features',
    version: '1.7.0',
  },

  {
    date: '2017-09-05',
    items: [
      {
        description: `Designer queue only shows rugs that are on stock.`,
        headline: 'Designer Queue Module',
        type: 'bugfix',
      },
      {
        description: `Uploaded TIFs should have a white background instead of black.`,
        headline: 'Rug Detail Module',
        type: 'bugfix',
      },
      {
        description: `Only Designers should be able to download raw versions of pictures.`,
        headline: 'Rug Detail Module',
        type: 'bugfix',
      },
    ],
    title: 'Bugfixes',
    version: '1.7.1',
  },

  {
    date: '2017-09-27',
    items: [
      {
        description: `Designer queue now shows rugs that are of unknown status & on consignment. Thanks to David for the suggestion.`,
        headline: 'Designer Queue Module',
        type: 'improvement',
      },
    ],
    title: 'Improvement',
    version: '1.7.2',
  },

  {
    date: '2017-09-30',
    items: [
      {
        description: `Showing a progress loader when uploading pictures.`,
        headline: 'Rug Detail Module',
        type: 'improvement',
      },
      {
        description: `QC pictures are now clearly marked.`,
        headline: 'Rug Detail Module',
        type: 'improvement',
      },
      {
        description: `QC pictures are now only visible to advisors & designers.`,
        headline: 'Rug Detail Module',
        type: 'improvement',
      },
      {
        description: `A rug can now show the status knotting.`,
        headline: 'General',
        type: 'improvement',
      },
      {
        description: `Fixed picture count.`,
        headline: 'General',
        type: 'bugfix',
      },
      {
        description: `When applying extended filters, the currently chosen filters (which are not yet applied) are now also correctly applied.`,
        headline: 'Search Module',
        type: 'bugfix',
      },
    ],
    title: 'Improvements & Bugfixes',
    version: '1.7.3',
  },

  {
    date: '2017-10-08',
    items: [
      {
        description: `Renamed picture file types to more intuitive names.`,
        headline: 'Rug Detail Module',
        type: 'improvement',
      },
      {
        description: `Improved method for determining a rug's status.`,
        headline: 'General',
        type: 'improvement',
      },
    ],
    title: 'Improvements & Bugfixes',
    version: '1.7.4',
  },

  {
    date: '2017-10-21',
    items: [
      {
        description: `Certain actions now prompt a confirmation modal. When accepted, the action is applied. For example when setting a new primary picture.`,
        headline: 'General',
        type: 'feature',
      },
      {
        description: `Certain actions now prompt a popup to provide feedback about whether the action was successful or not. For example, when marking a rug for designers.`,
        headline: 'General',
        type: 'feature',
      },
      {
        description: `An Advisor's own rugs are only pinned to the front if they contain current and upcoming reservations.`,
        headline: 'My Orders Module (Advisors)',
        type: 'improvement',
      },
      {
        description: `Rugs assigned to another advisor are only shown (and pinned to the front) if they contain current and upcoming reservations that the user has created.`,
        headline: 'My Orders Module (Advisors)',
        type: 'improvement',
      },
      {
        description: `If no rugs are marked for designers, six recent rugs should now be shown on the homepage.`,
        headline: 'Main Module',
        type: 'bugfix',
      },
      {
        description: `Fixed reordering and showing incorrect pictures when previewing pictures of a rug.`,
        headline: 'Rug Detail Module',
        type: 'bugfix',
      },
    ],
    title: 'Features, Improvements, and Bugfixes',
    version: '1.8.0',
  },

  {
    date: '2018-02-01',
    items: [
      {
        description: `Advisors can now see all pictures of all events or search for individual emails across all events.`,
        headline: 'Family Album Integration',
        type: 'feature',
      },
      {
        description: `Feedback emails weren't correctly sent. This is now fixed. If you wrote use feedback in the last two months, please try it again. We're sorry.`,
        headline: 'General',
        type: 'bugfix',
      },
      {
        description: `When uploading designer pictures, the JPG now has a white background.`,
        headline: 'Rug Detail Module',
        type: 'bugfix',
      },
    ],
    title: 'New Feature & Bugfixes',
    version: '1.9.0',
  },

  {
    date: '2018-02-17',
    items: [
      {
        description: `It is now possible to download an excel file of all customer emails from a particular event.`,
        headline: 'Family Album',
        type: 'improvement',
      },
    ],
    title: 'Improvements',
    version: '1.9.1',
  },

  {
    date: '2018-02-23',
    items: [
      {
        description: `New Debug Module.`,
        headline: 'Debug (Administrators)',
        type: 'feature',
      },
    ],
    title: 'Features',
    version: '1.9.2',
  },

  {
    date: '2018-04-12',
    items: [
      {
        description: `New button to get back to the events overview in the Family Album Module.`,
        headline: 'Family Album',
        type: 'improvement',
      },
      {
        description: `When a designer fulfills a designer picture request, all designers get an email that the request is fulfilled. Thanks to Malena for the suggestion.`,
        headline: 'Requested Rugs',
        type: 'improvement',
      },
    ],
    title: 'Improvements',
    version: '1.9.3',
  },

  {
    date: '2018-08-15',
    items: [
      {
        description: `Designer requests should now be grouped together inside a thread in Gmail. Thanks to Malena for the suggestion.`,
        headline: 'Requested Rugs',
        type: 'improvement',
      },
      {
        description: `When searching for rugs, the unknown status can be selected as well. Thanks to Janna for the suggestion.`,
        headline: 'Search',
        type: 'improvement',
      },
      {
        description: `If a rug is on consignment, it should display the consignment date instead of invoice date. Thanks to David for the suggestion.`,
        headline: 'Rug Detail',
        type: 'improvement',
      },
      {
        description: `Newly taken pictures should now be saved without any EXIF data. Thanks to Benedikt for the suggestion.`,
        headline: 'Rug Detail',
        type: 'improvement',
      },
    ],
    title: 'Improvements',
    version: '1.9.4',
  },
  {
    date: '2018-10-27',
    items: [
      {
        description: `Moved to group-based permission management. Administrators can now create groups and manage their permissions.`,
        headline: 'General',
        type: 'feature',
      },
      {
        description: `Significantly increased the initial loading of all rugs.`,
        headline: 'General',
        type: 'improvement',
      },
    ],
    title: 'Group-Based Permission Management & Performance Improvement',
    version: '1.10.0',
  },
]
